module.exports = __webpack_public_path__ + "static/wiczlino1-632dae8c13ea313eb8e0cc1efca9c8f1.png";